import { Button, IconButton, makeStyles, Slide } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import React from 'react';
import 'font-awesome/css/font-awesome.css';

const useStyles = makeStyles({
  contentRoot: {
    fontSize: 12,
    flexWrap: 'nowrap',
  },
});

const StyledSnackbarProvider = ({ children, autoHideDurationInSeconds = 10 }) => {
  const classes = useStyles();
  const notistackRef = React.createRef();

  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      action={key => (
        <IconButton onClick={onClickDismiss(key)} style={{ border: 'none' }}>
          <FontAwesomeIcon icon={faTimesCircle} color='white' size='lg' />
        </IconButton>
      )}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={1000 * autoHideDurationInSeconds}
      transitionDuration={{ enter: 200, exit: 200 }}
      TransitionComponent={Slide}
      classes={classes}
      preventDuplicate
    >
      {children}
    </SnackbarProvider>
  );
};

export default StyledSnackbarProvider;
